import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative border-y border-line bg-ink-800/40 overflow-hidden">
      <div className="mx-auto max-w-5xl px-5 md:px-8 py-24 md:py-32 text-center">
        <Reveal><span className="overline">Testimonials</span></Reveal>
        <Quote className="mx-auto mt-6 text-orange" size={40} />
        <div className="relative mt-6 min-h-[160px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              data-testid="testimonial"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              className="max-w-3xl"
            >
              <p className="font-head font-bold text-2xl md:text-3xl leading-snug tracking-tight">
                "{TESTIMONIALS[i].quote}"
              </p>
              <footer className="mt-6 text-white/60 text-sm uppercase tracking-wider">
                <span className="text-orange">{TESTIMONIALS[i].author}</span> · {TESTIMONIALS[i].role}
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
        <div className="mt-8 flex justify-center gap-2">
          {TESTIMONIALS.map((_, idx) => (
            <button
              key={idx}
              data-testid={`testimonial-dot-${idx}`}
              onClick={() => setI(idx)}
              className={`h-2 transition-all ${idx === i ? "w-8 bg-orange" : "w-2 bg-white/25"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
